import React from 'react';
import SelectInput from '../../controls/selectInput.jsx';
import { apiGet, apiPost } from '../../services/apiClient';
import { isUndefined } from 'util';

export default class DropDownFilter extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            column: this.props.column,
            value: this.props.value,
            loadUrl: this.props.loadUrl,
            options: []
        };

        this.updateLastValue();
    }

    componentDidMount() {
        this.reloadOptions();
    }

    componentWillReceiveProps(newProps) {
        this.state.column = newProps.column;
        this.state.value = newProps.value;
        this.updateLastValue();
        this.setState(this.state);
    }

	reloadOptions() {
        apiPost(this.state.loadUrl, { settings: this.props.gridSettings })
            .then(data => {
                let options = data.entries.map((entry, ind, array) => {
                    if (!isUndefined(entry.id)) {
                        return {
                            value: entry.id,
                            label: entry.name
                        };
                    } else {
                        return {
                            value: entry.value,
                            label: entry.value
                        };
                    }
                });
                this.setState({ options: options });
            });
	}

    updateLastValue() {
        this.lastValue = this.state.value ? this.state.value.value : null;
    }

    applyFilterChanges() {
        this.setState(this.state, () => {
            if (this.state.value) {
                if (this.state.value.value === null || this.state.value.value === undefined || this.state.value.value.length < 1) {
                    // игнорируем пустые значения фильтра
                    return;
                }
                if (this.lastValue === this.state.value.value) {
                    // если ничего не поменялось, сохранять не нужно
                    return;
                }
            } else if (!this.lastValue) {
                // фильтра как не было, так и нет, игнорируем
                return;
            }
            this.updateLastValue();
            this.props.onChange(this.state.column.fieldName, this.state.value);
        });
    }

    clearFilter() {
        this.state.value = null;
        this.applyFilterChanges();
    }

    ensureFilterValue() {
        if (!this.state.value) {
            this.state.value = {
                fieldName: this.state.column.fieldName,
                operation: "in",
                value: ""
            };
        }
    }

    handleFilterValueChange(selection) {
        if (selection
            && selection.value !== null
            && selection.value !== undefined
        ) {
            this.ensureFilterValue();
            if (this.state.value.value.length > 0) {
                this.state.value.value = this.state.value.value + ",";
            }
            this.state.value.value = this.state.value.value + selection.value;
            this.applyFilterChanges();
        }
    }

    handleFilterValueRemove(value) {
        if (this.state.value && this.state.value.value && this.state.value.value.length > 0) {
            let ids = this.state.value.value.split(',').map((id, ind, arr) => {
                let intId = parseInt(id);
                if (isNaN(intId)) {
                    return id;
                } else {
                    return intId;
                }
            });
            let newValue = "";
            ids.forEach((id, ind, arr) => {
                if (id !== value) {
                    if (newValue.length > 0) {
                        newValue = newValue + ",";
                    }
                    newValue = newValue + id;
                }
            });
            if (newValue && newValue.length > 0) {
                this.state.value.value = newValue;
            } else {
                this.state.value = null;
            }
            this.applyFilterChanges();
        }
    }

    render() {
        let filterOptions = this.state.options;
        if (this.state.value && this.state.value.value && this.state.value.value.length > 0) {
            let ids = this.state.value.value.split(',').map((id, ind, arr) => {
                let intId = parseInt(id);
                if (isNaN(intId)) {
                    return id;
                } else {
                    return intId;
                }
            });
            filterOptions = [];
            this.state.options.forEach((opt, ind, arr) => {
                if (ids.indexOf(opt.value) === -1) {
                    filterOptions.push(opt);
                }
            });
        }

        let selectedElements = [];
        if (this.state.value && this.state.value.value && this.state.value.value.length > 0) {
            selectedElements = this.state.value.value.split(',').map((valueId, ind, idsArr) => {
                let id = parseInt(valueId);
                if (isNaN(id)) {
                    id = valueId;
                }

                let option = null;
                this.state.options.forEach((optValue, optInd, optArr) => {
                    if (optValue.value === id) {
                        option = optValue;
                    }
                });

                let key = this.state.column.name + '-sel-' + id;

                return (
                    <div className="filter-select-option" key={key}>
                        <span className="filter-select-option-close"
                            aria-hidden="true"
                            onClick={() => this.handleFilterValueRemove(id)}
                        >
                            ×
                        </span>
                        <span className="filter-select-option-label">
                            {option ? option.label : ""}
                        </span>
                    </div>
                );
            });
        }

        return (
            <div className="input-group">
                <SelectInput options={filterOptions}
                    clearable={false}
                    value={null}
                    onChange={e => this.handleFilterValueChange(e)}
                    disabled={this.props.disabled}
                />
                <div className="filter-select-wrapper"
                    style={{ width: this.props.columnWidth }}
                >
                    {selectedElements}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/grid/filter/dropdownFilter.jsx